module.exports = __webpack_public_path__ + "img/demand.5c2a41b2.svg";